/**
 * Read-only legacy `rooms/*` access for one-time fallback / import.
 */
import * as legacy from "../../repositories/legacyRoomRepository";
import { newRegistryEntryId } from "../../features/registry/utils/ids";
import { normPlayer } from "../../features/match/shared/playerUtils";

export async function tryImportLegacyMeta(matchId) {
  return legacy.fetchRoomMeta(matchId);
}

export async function tryImportLegacyLive(matchId) {
  const snap = await legacy.fetchRoomLiveState(matchId);
  return snap;
}

export async function tryImportLegacyPlayers(matchId) {
  const data = await legacy.fetchRoomPlayers(matchId);
  return data?.players || [];
}

/**
 * Convert deprecated session `players[]` rows into registry entries on import.
 * @param {unknown[]} players
 * @param {string} roomId
 * @param {string} addedByUid
 */
export function legacyPlayersToRegistryEntries(players, roomId, addedByUid) {
  const out = [];
  const seen = new Set();
  for (const raw of players || []) {
    const row = normPlayer(raw);
    if (!row.name) continue;
    const key = row.name.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    const playerId =
      (typeof raw === "object" && raw?.playerId && String(raw.playerId).trim()) ||
      `legacy_${roomId}_${out.length}`;
    out.push({
      id: newRegistryEntryId(),
      roomId,
      playerId,
      displayName: row.name,
      avatar: null,
      userId: null,
      addedAt: Date.now(),
      addedBy: addedByUid,
      addedMethod: "import",
      active: true,
    });
  }
  return out;
}

export async function tryImportLegacyTeams(matchId) {
  const data = await legacy.fetchRoomTeams(matchId);
  return data?.teams || [];
}

export async function tryImportLegacyHistory(matchId) {
  const data = await legacy.fetchRoomHistory(matchId);
  return data?.history || [];
}
